const errorsAuthRedirect = {
  PrecisaCriarNovaSenha: "PrecisaCriarNovaSenha",
  PrecisaMudarSenha: "PrecisaMudarSenha",
  LoginSSO: "LoginSSO",
  UsuarioBloqueadoComIntegracaoFinanceira: "UsuarioBloqueadoComIntegracaoFinanceira",
};

export default errorsAuthRedirect;
